import { Button, ButtonProps } from "primereact/button";
import { NavLink } from "react-router-dom";

export function PrimeButton({
  route,
  pt,
  size,
  ...rest
}: ButtonProps & { route?: string }) {
  if (route) {
    return (
      <NavLink to={route}>
        <Button {...rest} />
      </NavLink>
    );
  }
  return (
    <Button
      pt={{
        root: (options) => {
          let restContent: void | React.HTMLAttributes<HTMLButtonElement> =
            undefined;
          if (pt?.root) {
            if (pt.root instanceof Function) {
              restContent = pt.root(options);
            } else {
              restContent = pt.root;
            }
          }
          return {
            ...restContent,
            className: `
              ${size === "small" ? "!px-2 !py-0 !w-auto" : ""}
              ${size === "large" ? "!px-6 !py-4 !w-auto" : ""}${size === "large" ? "" : ""}
              ${options?.props.label && options?.props.icon ? "flex gap-2" : ""}
              ${restContent?.className ? ` ${restContent.className}` : ""}`,
          };
        },
      }}
      {...rest}
    />
  );
}
